import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'jobCardAddressGroup'
})
export class JobCardAddressGroupPipe implements PipeTransform {

  transform(value: Array<any> | undefined): unknown {

    if (!value)
      return '';

    const organizedData : { [key: string]: string[] } = value.reduce((acc, item:any) => {
      if (!acc[item.jobAddress1]) {
        acc[item.jobAddress1] = [];
      }
      acc[item.jobAddress1].push(item.jobAddress3);
      return acc;
    }, {});
    
    const result = Object.entries(organizedData)
      .map(([key, values]) => `${values.join(' & ')}, ${key}.`)
      .join(' ');

      return result;
  }

}
